/**
 * API утилиты для работы с backend
 */

import axios from 'axios'

// Создаем экземпляр axios с базовой конфигурацией
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  timeout: 180000, // 3 минуты
  headers: {
    'Content-Type': 'application/json'
  }
})

// Interceptor для добавления токена авторизации
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('dashboard_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    console.error('❌ Ошибка запроса:', error)
    return Promise.reject(error)
  }
)

// Interceptor для обработки ответов
apiClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Логируем ошибки API
    console.error('❌ Ошибка API:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: error.response?.data?.detail || error.message
    })

    // Обработка ошибок авторизации
    if (error.response?.status === 401) {
      console.log('🔐 Ошибка авторизации, перенаправляем на логин')

      // Очищаем токен
      localStorage.removeItem('dashboard_token')

      // Перенаправляем на страницу логина (если не находимся на ней уже)
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }

    return Promise.reject(error)
  }
)

export default apiClient

// Экспортируем дополнительные утилиты
export const ApiUtils = {
  /**
   * Обработка ошибок API для показа пользователю
   */
  getErrorMessage: (error) => {
    if (error.response?.data?.detail) {
      return error.response.data.detail
    }

    if (error.response?.status) {
      const statusMessages = {
        400: 'Неверные данные запроса',
        401: 'Необходима авторизация',
        403: 'Доступ запрещен',
        404: 'Ресурс не найден',
        429: 'Слишком много запросов',
        500: 'Внутренняя ошибка сервера',
        502: 'Сервер недоступен',
        503: 'Сервис временно недоступен'
      }

      return statusMessages[error.response.status] || `Ошибка ${error.response.status}`
    }

    if (error.code === 'ECONNABORTED') {
      return 'Время ожидания запроса истекло'
    }

    if (error.code === 'ERR_NETWORK') {
      return 'Ошибка сетевого подключения'
    }

    return error.message || 'Неизвестная ошибка'
  },

  /**
   * Создание параметров для GET запроса из объекта
   */
  createQueryParams: (params) => {
    const searchParams = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== '') {
        if (Array.isArray(value)) {
          value.forEach(item => searchParams.append(key, item))
        } else {
          searchParams.append(key, value)
        }
      }
    })

    return searchParams.toString()
  },

  /**
   * Загрузка файла из blob ответа
   */
  downloadFile: (response, filename) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
}